import { connect } from 'react-redux';
import KomposisiSiswaAgama from '../../../views/Kurikulum/Analisa/KomposisiSiswaAgama.kurikulum.view.js';
import { getStudent } from '../../../states/thunks/student.thunk';


function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}
export default connect(null, mapDispatchToProps)(KomposisiSiswaAgama);
